<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path">
        <router-link :to="item.redirect||item.path">{{item.meta.title? item.meta.title : parentTitle}}</router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
  export default {
    created() {
      this.getBreadcrumb()
    },
    data() {
      return {
        levelList: null,
        parentTitle: ''
      }
    },
    watch: {
      $route() {
        this.getBreadcrumb()
      }
    },
    methods: {
      getBreadcrumb() {
        // let matched = this.$route.matched.filter(item => item.name)
        // const first = matched[0]
        // if (first && first.name !== 'dashboard') {
        //   // matched = [{ path: '/welcome', meta: { title: 'Dashboard123' }}].concat(matched)
        //   matched = [{ path: first.path, meta: { title: first.name }}].concat(matched)
        // }
        // console.log(this.$route);
        this.parentTitle = this.$route.meta.parentTitle;
        this.levelList = this.$route.matched;
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue